import React from "react";
import TwoFa from "../elements/twoFa/TwoFa";

import { StyledForm, StyledFormContent } from "../styles/styledForm";
import { StyledLoginFormHead, StyleFormTitle } from "./styledLogin";


const LoginConfirmForm = ({handleSubmit, error, t}) => {
  return (
    <StyledForm as="div" className="login-form">
      <StyledLoginFormHead>
        <StyleFormTitle as="h2">
          {t("twofaTitle")}
        </StyleFormTitle>
      </StyledLoginFormHead>
      <StyledFormContent className="login-form__content">
        <TwoFa
          handleSubmit={handleSubmit}
          error={error}
        />
      </StyledFormContent>
    </StyledForm>
  );
};

export default LoginConfirmForm;